import React, { useEffect } from "react";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";

const Complete = () => {
  let [searchParams, setSearchParams] = useSearchParams();

  const txid = searchParams.get("transactionId");
  const order_id = localStorage.getItem("litewallet_order_id");

  useEffect(() => {
    return () => {
      localStorage.clear();
    };
  });

  return (
    <div>
      <H1>Processing order...</H1>
      <P>
        Our partner Moonpay is now processing you order... In the meanwhile
        please write down your Order ID and Transaction ID.
      </P>

      <P>Order ID: {order_id}</P>
      <P>Transaction ID: {txid}</P>
      <A href="https://support.moonpay.com/hc/en-gb">Any Issues? Get help.</A>
    </div>
  );
};

const H1 = styled.h1`
  font-size: 18px;
  color: #333333;
  padding-top: 30px;
  padding-left: 30px;
`;

const P = styled.p`
  padding-left: 30px;
  padding-right: 30px;
`;

const A = styled.a`
  padding-left: 30px;
  padding-right: 30px;
`;

export default Complete;
